const getComponentLoaded = (state) => {
  return state.componentLoaded;
};

export default {
  getComponentLoaded
};
